import React from "react";
import ConfirmDialog from "../../../components/shared/ConfirmDialog";
import { OwcButton } from "@one/react";
import CustomList from "../../../components/shared/List";

const BulkRemovalDialog = ({
  open,
  onClose,
  rows,
  onConfirm,
  loading,
  summaryLabel,
  tableMeta,
  mapRow,
}) => {
  return (
    <ConfirmDialog
      open={open}
      close={onClose}
      onCancel={onClose}
      title="Confirm bulk remove"
      renderActions={() => (
        <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
          <OwcButton variant="secondary" flat onClick={onClose}>
            Cancel
          </OwcButton>
          <OwcButton variant="primary" flat disabled={!rows.length || loading} onClick={onConfirm}>
            Remove
          </OwcButton>
        </div>
      )}
    >
      <div style={{ marginBottom: 12 }}>
        The following {rows.length} {summaryLabel}
        {rows.length === 1 ? "" : "s"} will be removed.
      </div>
      <CustomList
        meta={tableMeta}
        data={rows.map(mapRow)}
        loading={false}
      />
    </ConfirmDialog>
  );
};

export default BulkRemovalDialog;
